import _JSXStyle from "styled-jsx/style";
import { spacers } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
import { borderColor } from './common/index.js';
export const LeftFooter = _ref => {
  let {
    children,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["3629116366", [borderColor, spacers.dp8]]])
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3629116366",
    dynamic: [borderColor, spacers.dp8]
  }, ["div.__jsx-style-dynamic-selector{-webkit-box-flex:0;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;border-top:1px solid ".concat(borderColor, ";padding:0 ").concat(spacers.dp8, ";}")]));
};
LeftFooter.propTypes = {
  children: PropTypes.node,
  dataTest: PropTypes.string
};